__webpack_require__.p = "https://import-staging-0-48-dev1.berger-shop.de/";